// @ts-nocheck
export const localeCodes =  [
  "de",
  "en",
  "es",
  "fr",
  "it",
  "nl",
  "pt"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_241d6561",
      load: () => import("#nuxt-i18n/241d6561" /* webpackChunkName: "locale_de_46json_241d6561" */),
      cache: true
    },
    {
      key: "locale_de_46json_ef9166ef",
      load: () => import("#nuxt-i18n/ef9166ef" /* webpackChunkName: "locale_de_46json_ef9166ef" */),
      cache: true
    },
    {
      key: "locale_de_46json_d7f9ac57",
      load: () => import("#nuxt-i18n/d7f9ac57" /* webpackChunkName: "locale_de_46json_d7f9ac57" */),
      cache: true
    },
    {
      key: "locale_de_46json_a611d8a0",
      load: () => import("#nuxt-i18n/a611d8a0" /* webpackChunkName: "locale_de_46json_a611d8a0" */),
      cache: true
    },
    {
      key: "locale_de_46json_8034cd86",
      load: () => import("#nuxt-i18n/8034cd86" /* webpackChunkName: "locale_de_46json_8034cd86" */),
      cache: true
    },
    {
      key: "locale_de_46json_d82699ae",
      load: () => import("#nuxt-i18n/d82699ae" /* webpackChunkName: "locale_de_46json_d82699ae" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_8e6ec66e",
      load: () => import("#nuxt-i18n/8e6ec66e" /* webpackChunkName: "locale_en_46json_8e6ec66e" */),
      cache: true
    },
    {
      key: "locale_en_46json_62ff4403",
      load: () => import("#nuxt-i18n/62ff4403" /* webpackChunkName: "locale_en_46json_62ff4403" */),
      cache: true
    },
    {
      key: "locale_en_46json_2f78f4ba",
      load: () => import("#nuxt-i18n/2f78f4ba" /* webpackChunkName: "locale_en_46json_2f78f4ba" */),
      cache: true
    },
    {
      key: "locale_en_46json_986b16bf",
      load: () => import("#nuxt-i18n/986b16bf" /* webpackChunkName: "locale_en_46json_986b16bf" */),
      cache: true
    },
    {
      key: "locale_en_46json_296f1f06",
      load: () => import("#nuxt-i18n/296f1f06" /* webpackChunkName: "locale_en_46json_296f1f06" */),
      cache: true
    },
    {
      key: "locale_en_46json_50193685",
      load: () => import("#nuxt-i18n/50193685" /* webpackChunkName: "locale_en_46json_50193685" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_476cfa2f",
      load: () => import("#nuxt-i18n/476cfa2f" /* webpackChunkName: "locale_es_46json_476cfa2f" */),
      cache: true
    },
    {
      key: "locale_es_46json_8f9f761e",
      load: () => import("#nuxt-i18n/8f9f761e" /* webpackChunkName: "locale_es_46json_8f9f761e" */),
      cache: true
    },
    {
      key: "locale_es_46json_cf794b02",
      load: () => import("#nuxt-i18n/cf794b02" /* webpackChunkName: "locale_es_46json_cf794b02" */),
      cache: true
    },
    {
      key: "locale_es_46json_4ef8e539",
      load: () => import("#nuxt-i18n/4ef8e539" /* webpackChunkName: "locale_es_46json_4ef8e539" */),
      cache: true
    },
    {
      key: "locale_es_46json_bb7d0d63",
      load: () => import("#nuxt-i18n/bb7d0d63" /* webpackChunkName: "locale_es_46json_bb7d0d63" */),
      cache: true
    },
    {
      key: "locale_es_46json_069aa9e1",
      load: () => import("#nuxt-i18n/069aa9e1" /* webpackChunkName: "locale_es_46json_069aa9e1" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_659ec961",
      load: () => import("#nuxt-i18n/659ec961" /* webpackChunkName: "locale_fr_46json_659ec961" */),
      cache: true
    },
    {
      key: "locale_fr_46json_520d4107",
      load: () => import("#nuxt-i18n/520d4107" /* webpackChunkName: "locale_fr_46json_520d4107" */),
      cache: true
    },
    {
      key: "locale_fr_46json_f38b6677",
      load: () => import("#nuxt-i18n/f38b6677" /* webpackChunkName: "locale_fr_46json_f38b6677" */),
      cache: true
    },
    {
      key: "locale_fr_46json_b81b146b",
      load: () => import("#nuxt-i18n/b81b146b" /* webpackChunkName: "locale_fr_46json_b81b146b" */),
      cache: true
    },
    {
      key: "locale_fr_46json_ddf3b3b7",
      load: () => import("#nuxt-i18n/ddf3b3b7" /* webpackChunkName: "locale_fr_46json_ddf3b3b7" */),
      cache: true
    },
    {
      key: "locale_fr_46json_99361b2a",
      load: () => import("#nuxt-i18n/99361b2a" /* webpackChunkName: "locale_fr_46json_99361b2a" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_5ffd1e7e",
      load: () => import("#nuxt-i18n/5ffd1e7e" /* webpackChunkName: "locale_it_46json_5ffd1e7e" */),
      cache: true
    },
    {
      key: "locale_it_46json_7255a261",
      load: () => import("#nuxt-i18n/7255a261" /* webpackChunkName: "locale_it_46json_7255a261" */),
      cache: true
    },
    {
      key: "locale_it_46json_36a148f8",
      load: () => import("#nuxt-i18n/36a148f8" /* webpackChunkName: "locale_it_46json_36a148f8" */),
      cache: true
    },
    {
      key: "locale_it_46json_76adc59a",
      load: () => import("#nuxt-i18n/76adc59a" /* webpackChunkName: "locale_it_46json_76adc59a" */),
      cache: true
    },
    {
      key: "locale_it_46json_f021d765",
      load: () => import("#nuxt-i18n/f021d765" /* webpackChunkName: "locale_it_46json_f021d765" */),
      cache: true
    },
    {
      key: "locale_it_46json_cbce9093",
      load: () => import("#nuxt-i18n/cbce9093" /* webpackChunkName: "locale_it_46json_cbce9093" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_14e6e17d",
      load: () => import("#nuxt-i18n/14e6e17d" /* webpackChunkName: "locale_nl_46json_14e6e17d" */),
      cache: true
    },
    {
      key: "locale_nl_46json_d13c63f1",
      load: () => import("#nuxt-i18n/d13c63f1" /* webpackChunkName: "locale_nl_46json_d13c63f1" */),
      cache: true
    },
    {
      key: "locale_nl_46json_f8cf21fc",
      load: () => import("#nuxt-i18n/f8cf21fc" /* webpackChunkName: "locale_nl_46json_f8cf21fc" */),
      cache: true
    },
    {
      key: "locale_nl_46json_227b18d2",
      load: () => import("#nuxt-i18n/227b18d2" /* webpackChunkName: "locale_nl_46json_227b18d2" */),
      cache: true
    },
    {
      key: "locale_nl_46json_e774dfec",
      load: () => import("#nuxt-i18n/e774dfec" /* webpackChunkName: "locale_nl_46json_e774dfec" */),
      cache: true
    },
    {
      key: "locale_nl_46json_8b0818c9",
      load: () => import("#nuxt-i18n/8b0818c9" /* webpackChunkName: "locale_nl_46json_8b0818c9" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_97a4f51f",
      load: () => import("#nuxt-i18n/97a4f51f" /* webpackChunkName: "locale_pt_46json_97a4f51f" */),
      cache: true
    },
    {
      key: "locale_pt_46json_774f6148",
      load: () => import("#nuxt-i18n/774f6148" /* webpackChunkName: "locale_pt_46json_774f6148" */),
      cache: true
    },
    {
      key: "locale_pt_46json_50e36c84",
      load: () => import("#nuxt-i18n/50e36c84" /* webpackChunkName: "locale_pt_46json_50e36c84" */),
      cache: true
    },
    {
      key: "locale_pt_46json_239f9403",
      load: () => import("#nuxt-i18n/239f9403" /* webpackChunkName: "locale_pt_46json_239f9403" */),
      cache: true
    },
    {
      key: "locale_pt_46json_b78ebfd1",
      load: () => import("#nuxt-i18n/b78ebfd1" /* webpackChunkName: "locale_pt_46json_b78ebfd1" */),
      cache: true
    },
    {
      key: "locale_pt_46json_44945213",
      load: () => import("#nuxt-i18n/44945213" /* webpackChunkName: "locale_pt_46json_44945213" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch"
  },
  {
    code: "en",
    language: "en-US",
    name: "English"
  },
  {
    code: "es",
    language: "es-ES",
    name: "Español"
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français"
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italiano"
  },
  {
    code: "nl",
    language: "nl-NL",
    name: "Dutch"
  },
  {
    code: "pt",
    language: "pt-PT",
    name: "Português"
  }
]
/** client **/

/** client-end **/